import { connect } from "react-redux";
import MaintenanceChangeAssignee from "./maintenanceChangeAssignee";
import { bindActionCreators } from "redux";
import {
    getAssigneeList,
    postAssignee
} from 'services/redux/brandActivtion/siteMaintenance/action';
const mapStateToProps = (state) => ({
    assigneeList: state.baSiteListingReducer.assigneeList,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getAssigneeList,
            postAssignee
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(MaintenanceChangeAssignee);
